<label>{{ label }}</label>
<ng-select
  [items]="staffs"
  [searchFn]="staffSearchFn"
  bindValue="id"
  [(ngModel)]="value"
  (change)="onChange()"
  [multiple]="options?.multi"
  style="min-width: 140px"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"
      >×</span
    >
    {{ item.firstname }} {{ item.lastname }} ({{ item.email }})
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-search="searchTerm"
  >
    <h6>{{ item.firstname }} {{ item.lastname }} ({{ item.email }})</h6>
  </ng-template>
</ng-select>
